import { parse } from 'query-string';

import {
  HIGHLIGHT_BAR,
  SET_METRICS_EXPANDED,
  SET_LATEST_METRICS_ONLY,
  SET_CONCERNING_METRICS_ONLY,
  SET_METRICS_SORTER,
  LOCATION_CHANGE,
  SET_SHOW_BUILD_COMPLEMENT,
  SET_SHOW_SOURCES
} from './../actions';
import * as installerFileActions from '../actions/installerFiles';
import { jiraScansActionTypes } from './../actions/types';
import { build as constants } from './../helpers';

const initialState = {
  buildInfo: {
    product: '',
    buildType: '',
    buildNumber: 0
  },
  baselineBuildInfo: {
    product: constants.PRODUCTS.AXIOM,
    buildType: constants.LATEST_BY_IMAGE,
    buildNumber: 0
  },
  highlightedMetricImage: '',
  loadingJiraScans: false,
  metricsExpanded: true,
  installerExpanded: false,
  latestMetricsOnly: true,
  concerningMetricsOnly: true,
  showBuildComplement: false,
  metricsSorter: {
    id: 0,
    ascending: true
  },
  showSources: true
};

const buildPage = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (!action.payload ||
          !action.payload.search ||
          action.payload.pathname !== '/build') {
        return state;
      }

      // These are:
      // t: current build type
      // n: current build number
      // p: current product
      // bt: baseline build type
      // bn: baseline build number
      // bp: baseline product
      // The names need to be short because they're part of the URL query.
      const { t, n, p, bt, bn, bp } = parse(action.payload.search);
      const parseBuildInfo = (
        buildType,
        buildNumber,
        product,
        buildInfo
      ) => {
        const parsedBn = parseInt(buildNumber);
        if (buildType === 'release') {
          buildType = constants.LATEST_RELEASE;
        }

        return {
          ...buildInfo,
          buildType: buildType || buildInfo.buildType,
          buildNumber: buildNumber && !isNaN(parsedBn) ?
            parsedBn :
            buildInfo.buildNumber,
          product: product || buildInfo.product
        };
      };

      const baselineBuildInfo = parseBuildInfo(bt, bn, bp, state.baselineBuildInfo);
      return {
        ...state,
        buildInfo: parseBuildInfo(t, n, p, state.buildInfo),
        baselineBuildInfo: {
          ...baselineBuildInfo,
          product: baselineBuildInfo.product ||
            constants.BUILD_TYPE_VALUES[constants.LATEST_RELEASE][0].value
        }
      };
    case HIGHLIGHT_BAR:
      return {
        ...state,
        highlightedMetricImage: action.image
      };
    case SET_METRICS_EXPANDED:
      return {
        ...state,
        metricsExpanded: action.expanded
      };
    case SET_LATEST_METRICS_ONLY:
      return {
        ...state,
        latestMetricsOnly: action.latestMetricsOnly
      };
    case SET_SHOW_SOURCES:
      return {
        ...state,
        showSources: action.showSources
      };
    case SET_CONCERNING_METRICS_ONLY:
      return {
        ...state,
        concerningMetricsOnly: action.concerningMetricsOnly
      };
    case SET_METRICS_SORTER:
      return {
        ...state,
        metricsSorter: action.sorter
      };
    case installerFileActions.SET_INSTALLER_EXPANDED:
      return {
        ...state,
        installerExpanded: action.expanded
      };
    case jiraScansActionTypes.request:
      return {
        ...state,
        loadingJiraScans: true
      };
    case jiraScansActionTypes.success:
    case jiraScansActionTypes.failure:
      return {
        ...state,
        loadingJiraScans: false
      };
    case SET_SHOW_BUILD_COMPLEMENT:
      return {
        ...state,
        showBuildComplement: action.show
      };
    default:
      return state;
  }
};

export default buildPage;

const getBuildPage = state => state.buildPage;
export const getBuildInfo = state => getBuildPage(state).buildInfo;
export const getBaselineBuildInfo = state => getBuildPage(state).baselineBuildInfo;
export const getHighlightedMetricImage = state =>
  getBuildPage(state).highlightedMetricImage;
export const getMetricsExpanded = state =>
  getBuildPage(state).metricsExpanded;
export const getLatestMetricsOnly = state =>
  getBuildPage(state).latestMetricsOnly;
export const getConcerningMetricsOnly = state =>
  getBuildPage(state).concerningMetricsOnly;
export const getMetricsSorter = state => getBuildPage(state).metricsSorter;
export const getInstallerExpanded = state => getBuildPage(state).installerExpanded;
export const areJiraScansLoading = state => getBuildPage(state).loadingJiraScans;
export const getShowBuildComplement = state => getBuildPage(state).showBuildComplement;
export const getShowSources = state => getBuildPage(state).showSources;


// WEBPACK FOOTER //
// src/reducers/buildPage.js